export async function addApi(params) {
  return usePost('/customer/save', params);
}
export async function getListApi(params) {
  return usePost('/customer/lists', params);
}
export async function doctorListApi() {
  return useGet('/doctor/');
}